export const donorApi = {
  uploadExcel: (axiosAPI, formData) =>
    axiosAPI.post("/api/donor/upload-excel", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  uploadBulkExcel: (axiosAPI, formData) =>
    axiosAPI.post("/api/donor/upload-bulk-excel", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  getDonors: (axiosAPI, queryString) =>
    axiosAPI.get(`/api/donor/get-donor?${queryString}`),

  updateDonorById: (axiosAPI, donorId, payload) =>
    axiosAPI.put(`/api/donor/update-user-by-id/${donorId}`, payload),

  addDonor: (axiosAPI, payload) =>
    axiosAPI.post("/api/donor/add-donor", payload),

  getReceiptDetails: (axiosAPI, donorId) =>
    axiosAPI.get(`/api/donor/download-patron-card/${donorId}`),

  downloadDonorExcel: (axiosAPI, tableName, queryString) =>
    axiosAPI.get(
      `/api/donor/download-donor-excel?table=${tableName}&${queryString}`,
      {
        responseType: "blob",
      },
    ),

  getDonorById: (axiosAPI, donorId) =>
    axiosAPI.get(`/api/donor/get-user-by-id/${donorId}`),

  changePassword: (axiosAPI, donorId, payload) =>
    axiosAPI.put(`/api/donor/change-password/${donorId}`, payload),

  deleteDonorById: (axiosAPI, donorId) =>
    axiosAPI.delete(`/api/donor/delete-donor/${donorId}`),
};
